import Vue from 'vue'
import App from './App.vue'

import '@/bootstrap/app'
import '@/bootstrap/settings'
import '@/bootstrap/vendor'

import {$} from 'simpli-web-sdk'
import {store} from '@/store'

const ClickOutside = require('vue-click-outside')

new Vue({
  router: $.router,
  i18n: $.i18n,
  store,
  render: (h) => h(App),
  directives: {
    ClickOutside,
  },
}).$mount('#app')

// @ts-ignore
window.appLoader.finish()
